import type { FC } from "react";
import type { IChartData } from "app/pages/website-analysis/audience-interests/single/types";
import ChartView from "pro-features/components/Chart/src/Chart";
import { chartTypes } from "app/UtilitiesAndConstants/Constants/ChartTypes";
import { getChartConfig } from "./getChartConfig";
import styled from "styled-components";
import { useCurrentStateAndParams } from "@uirouter/react";
import { NoData } from "app/pages/keyword-analysis/TotalTrafficPage/Components/UtilityComponents";

interface IChart {
    chartData: IChartData;
}

const Container = styled.div`
    padding: 0px 32px 16px 32px;
`;

export const Chart: FC<IChart> = (props) => {
    const { chartData = [] } = props;
    const { params } = useCurrentStateAndParams();
    const chartConfig = getChartConfig(params);
    return (
        <Container>
            {chartData.length > 0 ? (
                <ChartView
                    type={chartTypes.LINE}
                    data={chartData}
                    config={chartConfig}
                />
            ) : (
                <NoData
                    noDataTitleKey={"analysis.audience.interests.overlap.overtime.no.data.title"}
                    noDataSubTitleKey={"analysis.audience.interests.overlap.overtime.no.data.subtitle"}
                />
            )}
        </Container>
    );
};
